var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpears(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 156.332031 289.527344 L 143.667969 289.527344 L 143.667969 145.527344 C 143.667969 143.136719 145.605469 141.195313 148 141.195313 L 152 141.195313 C 154.394531 141.195313 156.332031 143.136719 156.332031 145.527344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 150.550781 90.945313 L 157.507813 136.222656 C 157.550781 136.496094 157.78125 136.695313 158.058594 136.695313 L 169.222656 136.695313 C 169.5625 136.695313 169.824219 136.390625 169.773438 136.054688 L 150.550781 10.945313 C 150.453125 10.3125 149.546875 10.3125 149.449219 10.945313 L 130.230469 136.054688 C 130.175781 136.390625 130.4375 136.695313 130.777344 136.695313 L 141.945313 136.695313 C 142.21875 136.695313 142.449219 136.496094 142.492188 136.222656 L 149.449219 90.945313 C 149.546875 90.3125 150.453125 90.3125 150.550781 90.945313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 105.667969 283.527344 L 93 283.527344 L 93 164.027344 C 93 161.636719 94.941406 159.695313 97.332031 159.695313 L 101.332031 159.695313 C 103.726563 159.695313 105.667969 161.636719 105.667969 164.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 99.882813 109.445313 L 106.839844 154.722656 C 106.882813 154.996094 107.113281 155.195313 107.390625 155.195313 L 118.554688 155.195313 C 118.894531 155.195313 119.15625 154.890625 119.105469 154.554688 L 99.882813 29.445313 C 99.785156 28.8125 98.878906 28.8125 98.78125 29.445313 L 79.5625 154.554688 C 79.511719 154.890625 79.769531 155.195313 80.113281 155.195313 L 91.277344 155.195313 C 91.550781 155.195313 91.785156 154.996094 91.824219 154.722656 L 98.78125 109.445313 C 98.878906 108.8125 99.785156 108.8125 99.882813 109.445313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 207 283.527344 L 194.332031 283.527344 L 194.332031 164.027344 C 194.332031 161.636719 196.273438 159.695313 198.667969 159.695313 L 202.667969 159.695313 C 205.058594 159.695313 207 161.636719 207 164.027344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 201.21875 109.445313 L 208.175781 154.722656 C 208.214844 154.996094 208.449219 155.195313 208.722656 155.195313 L 219.886719 155.195313 C 220.230469 155.195313 220.488281 154.890625 220.4375 154.554688 L 201.21875 29.445313 C 201.121094 28.8125 200.214844 28.8125 200.117188 29.445313 L 180.894531 154.554688 C 180.84375 154.890625 181.105469 155.195313 181.445313 155.195313 L 192.609375 155.195313 C 192.886719 155.195313 193.117188 154.996094 193.160156 154.722656 L 200.117188 109.445313 C 200.214844 108.8125 201.121094 108.8125 201.21875 109.445313 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpears);
export default __webpack_public_path__ + "static/media/Spears.478b2873f7cd1e73fca90445cb0b237a.svg";
export { ForwardRef as ReactComponent };